import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

/**
 * En-tête de page V8 — titre Syne accentué + sous-titre + zone d'actions projetée.
 * Le trio était recopié sur ~10 pages. Un sous-titre riche (liens, pipes complexes)
 * reste possible : ne pas passer `subtitle` et projeter un élément [slot=subtitle].
 *
 *   <wh-page-header title="Trackers" [subtitle]="count() + ' trackers'">
 *     <wh-button …>🧪 Create fake tracker</wh-button>
 *   </wh-page-header>
 */
@Component({
  selector: 'wh-page-header',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="flex flex-wrap items-start justify-between gap-3">
      <div>
        <h1 class="font-mono text-2xl font-semibold tracking-tight" [class]="titleClass()">{{ title() }}</h1>
        @if (subtitle()) {
          <p class="mt-1 max-w-3xl text-sm text-gray-500 dark:text-slate-400">{{ subtitle() }}</p>
        } @else {
          <ng-content select="[slot=subtitle]" />
        }
      </div>
      <div class="flex flex-wrap items-center gap-2">
        <ng-content />
      </div>
    </div>
  `,
})
export class WhPageHeaderComponent {
  readonly title = input.required<string>();
  readonly subtitle = input<string | null>(null);
  readonly accent = input<'primary' | 'warmYellow' | 'aquamarine' | 'electricPurple' | 'neutral'>('primary');

  protected readonly titleClass = computed(() => {
    switch (this.accent()) {
      case 'warmYellow':
        return 'text-warmYellow-500 dark:text-warmYellow-300';
      case 'aquamarine':
        return 'text-aquamarine-900 dark:text-aquamarine-300';
      case 'electricPurple':
        return 'text-eletricPurple-500 dark:text-eletricPurple-300';
      case 'neutral':
        return 'text-gray-900 dark:text-slate-100';
      default:
        return 'text-primary-500';
    }
  });
}
